import BigCommercePaymentsFastlaneUtils from './bigcommerce-payments-fastlane-utils';

export default function createBigCommercePaymentsFastlaneUtils(): BigCommercePaymentsFastlaneUtils {
    return new BigCommercePaymentsFastlaneUtils();
}
